function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import React from 'react';
import PropTypes from 'prop-types';
import Heading from '../Heading/Heading';
import Text from '../Text/Text';
import { jsx as ___EmotionJSX } from "@emotion/core";
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "gx0lhm",
  styles: "margin-bottom:0;"
} : {
  name: "gx0lhm",
  styles: "margin-bottom:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Zvb3Rlci9UZXh0cy5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0I0QiIsImZpbGUiOiIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Gb290ZXIvVGV4dHMuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuXG5pbXBvcnQgSGVhZGluZyBmcm9tICcuLi9IZWFkaW5nL0hlYWRpbmcnXG5pbXBvcnQgVGV4dCBmcm9tICcuLi9UZXh0L1RleHQnXG5cbmNvbnN0IFRleHRzID0gKHtcbiAgdGV4dCxcbiAgdGl0bGUsXG4gIGxpbmtUZXh0LFxuICB0YXJnZXQsXG4gIGhyZWYsXG4gIGxpbmtUZXh0SGFuZGxlQ2xpY2ssXG59KSA9PiAoXG4gIDxkaXY+XG4gICAge3RpdGxlICYmIChcbiAgICAgIDxIZWFkaW5nIGVsZW1lbnQ9J2g2JyBjc3M9e3sgbWFyZ2luQm90dG9tOiAwIH19PlxuICAgICAgICB7dGl0bGV9XG4gICAgICA8L0hlYWRpbmc+XG4gICAgKX1cbiAgICB7KHRleHQgfHwgbGlua1RleHQpICYmIChcbiAgICAgIDxUZXh0IGRpbW1lZCBzaXplPSd0NCc+XG4gICAgICAgIHt0ZXh0ICYmIDw+IHt0ZXh0fSAmbmJzcDsgPC8+fVxuICAgICAgICB7bGlua1RleHQgJiZcbiAgICAgICAgICAoKGhyZWYgJiYgIWxpbmtUZXh0SGFuZGxlQ2xpY2sgJiYgKFxuICAgICAgICAgICAgPFRleHQgZWxlbWVudD0nYScgZGltbWVkIHNpemU9J3Q0JyBocmVmPXtocmVmfSB0YXJnZXQ9e3RhcmdldH0+XG4gICAgICAgICAgICAgIHtsaW5rVGV4dH1cbiAgICAgICAgICAgIDwvVGV4dD5cbiAgICAgICAgICApKSB8fFxuICAgICAgICAgICAgKCFocmVmICYmIGxpbmtUZXh0SGFuZGxlQ2xpY2sgJiYgKFxuICAgICAgICAgICAgICA8VGV4dFxuICAgICAgICAgICAgICAgIGVsZW1lbnQ9J2EnXG4gICAgICAgICAgICAgICAgb25DbGljaz17ZSA9PiB7XG4gICAgICAgICAgICAgICAgICBlLnByZXZlbnREZWZhdWx0KClcbiAgICAgICAgICAgICAgICAgIGxpbmtUZXh0SGFuZGxlQ2xpY2soZSlcbiAgICAgICAgICAgICAgICB9fVxuICAgICAgICAgICAgICAgIGRpbW1lZFxuICAgICAgICAgICAgICAgIHNpemU9J3Q0J1xuICAgICAgICAgICAgICAgIGhyZWY9e2hyZWZ9XG4gICAgICAgICAgICAgICAgdGFyZ2V0PXt0YXJnZXR9XG4gICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICB7bGlua1RleHR9XG4gICAgICAgICAgICAgIDwvVGV4dD5cbiAgICAgICAgICAgICkpKX1cbiAgICAgIDwvVGV4dD5cbiAgICApfVxuICA8L2Rpdj5cbilcblxuVGV4dHMucHJvcFR5cGVzID0ge1xuICB0ZXh0OiBQcm9wVHlwZXMuc3RyaW5nLFxuICB0aXRsZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgbGlua1RleHQ6IFByb3BUeXBlcy5zdHJpbmcsXG4gIHRhcmdldDogUHJvcFR5cGVzLnN0cmluZyxcbiAgaHJlZjogUHJvcFR5cGVzLnN0cmluZyxcbiAgbGlua1RleHRIYW5kbGVDbGljazogUHJvcFR5cGVzLmZ1bmMsXG59XG5cbmV4cG9ydCBkZWZhdWx0IFRleHRzXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var Texts = function Texts(_ref) {
  var text = _ref.text,
    title = _ref.title,
    linkText = _ref.linkText,
    target = _ref.target,
    href = _ref.href,
    linkTextHandleClick = _ref.linkTextHandleClick;
  return ___EmotionJSX("div", null, title && ___EmotionJSX(Heading, {
    element: "h6",
    css: _ref2
  }, title), (text || linkText) && ___EmotionJSX(Text, {
    dimmed: true,
    size: "t4"
  }, text && ___EmotionJSX(React.Fragment, null, " ", text, " \xA0 "), linkText && (href && !linkTextHandleClick && ___EmotionJSX(Text, {
    element: "a",
    dimmed: true,
    size: "t4",
    href: href,
    target: target
  }, linkText) || !href && linkTextHandleClick && ___EmotionJSX(Text, {
    element: "a",
    onClick: function onClick(e) {
      e.preventDefault();
      linkTextHandleClick(e);
    },
    dimmed: true,
    size: "t4",
    href: href,
    target: target
  }, linkText))));
};
Texts.propTypes = {
  text: PropTypes.string,
  title: PropTypes.string,
  linkText: PropTypes.string,
  target: PropTypes.string,
  href: PropTypes.string,
  linkTextHandleClick: PropTypes.func
};
export default Texts;